import { trackEvent } from "../../../trackEvent";

const test = ({ target }) => target.closest(".reviews");

const push = ({ target }) => {
    const productName = target.closest(".reviews")?.dataset?.gtmProductname ?? 'none';
    const shadowRoot = target?.shadowRoot;
    const activeElement = shadowRoot ? shadowRoot?.activeElement : null;
    const isStarRate = activeElement? activeElement?.classList.contains("bv-reviews-product-rating-star") : false;
    const isPopClose = activeElement? activeElement?.classList.contains("PopoverClose") : false;

    if (!activeElement || isPopClose) return;

    if (isStarRate) {
        trackEvent({
            'event': 'click_add_review',
            'event_type': 'click',
            'item_name': productName,
        });
        return;
    }

    trackEvent({
        'event': 'click_read_review',
        'event_type': 'click',
        'item_name': productName,
    });
}

export default {
  name: "bv-reviews",
  test,
  push
};